import { DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { IconLongForm } from 'src/assets/icons/IconLongForm';
import { IconShortForm } from 'src/assets/icons/IconShortForm';
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { PROJECT_TYPE } from 'src/data/project';

import { ProjectTypeButton } from './components/ProjectTypeButton';
import { useStyles } from './useStyles';

export const SelectNewProjectTypePopup = ({
  open,
  title,
  description,
  onSubmit,
  onClose,
  displayBackButton,
  narrow,
}) => {
  const styles = useStyles();

  return (
    <CustomDialog
      className={narrow ? styles.rootNarrow : styles.root}
      open={open}
      onClose={onClose}
      onBack={onClose}
      title={title || 'Select the editor to use with this project:'}
      displayBackButton={displayBackButton}
      data-testid="popupSelectNewProjectType"
      displayCloseIcon
      hideActions
    >
      <DialogContent className={styles.dialogContent}>
        {description && (
          <CustomTypography
            className={styles.description}
            variant={TYPOGRAPHY_VARIANT.regular16}
          >
            {description}
          </CustomTypography>
        )}

        <ProjectTypeButton
          className={styles.button}
          Icon={IconLongForm}
          title="Long-form editor"
          onClick={() => onSubmit({ projectType: PROJECT_TYPE.longFormBuilder })}
          data-testid="buttonLongForm"
        />

        <ProjectTypeButton
          className={styles.button}
          Icon={IconShortForm}
          title="Short-form editor"
          onClick={() => onSubmit({ projectType: PROJECT_TYPE.document })}
          data-testid="buttonShortForm"
        />
      </DialogContent>
    </CustomDialog>
  );
};

SelectNewProjectTypePopup.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  displayBackButton: PropTypes.bool,
  narrow: PropTypes.bool,
};
SelectNewProjectTypePopup.defaultProps = {
  title: null,
  description: null,
  displayBackButton: false,
  narrow: false,
};
